var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowFourth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM29.28 13.6C28.98 16.76 27.68 24.44 27.02 27.98C26.74 29.48 26.18 29.98 25.66 30.04C24.5 30.14 23.62 29.28 22.5 28.54C20.74 27.38 19.74 26.66 18.04 25.54C16.06 24.24 17.34 23.52 18.48 22.36C18.78 22.06 23.9 17.4 24 16.98C24.0139 16.9164 24.012 16.8503 23.9946 16.7876C23.9772 16.7249 23.9447 16.6673 23.9 16.62C23.78 16.52 23.62 16.56 23.48 16.58C23.3 16.62 20.5 18.48 15.04 22.16C14.24 22.7 13.52 22.98 12.88 22.96C12.16 22.94 10.8 22.56 9.78 22.22C8.52 21.82 7.54 21.6 7.62 20.9C7.66 20.54 8.16 20.18 9.1 19.8C14.94 17.26 18.82 15.58 20.76 14.78C26.32 12.46 27.46 12.06 28.22 12.06C28.38 12.06 28.76 12.1 29 12.3C29.2 12.46 29.26 12.68 29.28 12.84C29.26 12.96 29.3 13.32 29.28 13.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowFourth);
export default __webpack_public_path__ + "static/media/FollowFourth.4dcdb4872d50b2e68a53361f0b7c3e36.svg";
export { ForwardRef as ReactComponent };